import { startOfMonth, startOfYear, subDays } from 'date-fns';
import { create } from 'zustand/index';
import { persist } from 'zustand/middleware';

import type { IDates } from '../core/types/dateTypes';

interface StoreState {
  // pageTimeframe: IPageTimeframe;
  // setPageTimeframe: (pageTimeframe: IPageTimeframe) => void;
  // pageTitle: string;
  // setPageTitle: (pageTitle: string) => void;
  marketplaces: string[];
  setMarketplaces: (marketplace: string[]) => void;
  pageMarketplace: boolean | 'All' | 'Amazon';
  setPageMarketplace: (pageMarketplace: boolean | 'All' | 'Amazon') => void;
  currency: string;
  setCurrency: (currency: string) => void;
  dates: IDates;
  setDates: (dates: Partial<IDates>) => void;
}

export const useGlobalStore = create<StoreState>()(
  persist(
    (set) => ({
      // pageTimeframe: 'timeframe',
      // setPageTimeframe: (pageTimeframe) => set({ pageTimeframe }),
      // pageTitle: '',
      // setPageTitle: (pageTitle) => set({ pageTitle }),
      marketplaces: [],
      setMarketplaces: (marketplaces) => set({ marketplaces }),
      pageMarketplace: true,
      setPageMarketplace: (pageMarketplace) => set({ pageMarketplace }),
      currency: 'USD',
      setCurrency: (currency) => set({ currency }),
      dates: {
        tf_s: startOfYear(subDays(new Date(), 1)),
        tf_e: subDays(new Date(), 1),
        tp_s: startOfMonth(subDays(new Date(), 1)),
        tp_e: subDays(new Date(), 1),
        timeframe: 'mom',
      },
      setDates: (dates) => set((state) => ({ dates: { ...state.dates, ...dates } })),
    }),
    {
      name: 'global-store',
      partialize: (state) => ({ marketplaces: state.marketplaces }),
    },
  ),
);
